import axios from '../../config/axios-config';
import * as actionTypes from './allActionList';

const successUploadAvatar = () => {
  return {
    type: actionTypes.SUCCESS_UPLOAD_AVATAR,
  };
};

const failedUploadAvatar = () => {
  return {
    type: actionTypes.FAILED_UPLOAD_AVATAR,
  };
};

export const uploadAvatar = (file) => {
  const fd = new FormData();
  fd.append('avatar', file, file.name);

  return async (dispatch) => {
    try {
      await axios.post('/users/me/avatar', fd, {
        headers: {
          'x-auth': localStorage.getItem('x-auth-token'),
        },
      });
      dispatch(successUploadAvatar());
    } catch (e) {
      dispatch(failedUploadAvatar());
    }
  };
};

const startedUploadingAvatar = () => {
  return {
    type: actionTypes.STARTED_UPLOADING_AVATAR,
  };
};

export const failedUploadingAvatar = (message) => {
  return {
    type: actionTypes.FAILED_UPLOADING_AVATAR,
    message,
  };
};

const finishedUploadingAvatar = () => {
  return {
    type: actionTypes.FINISHED_UPLOADING_AVATAR,
  };
};

const updateAvatarUploadProgress = (value) => {
  return {
    type: actionTypes.UPDATE_AVATAR_UPLOAD_PROGRESS,
    value,
  };
};

export const resetUploadingAvatarState = () => {
  return {
    type: actionTypes.RESET_UPLOADING_AVATAR_STATE,
  };
};

export const uploadAvatarRevamp = (file, cancelToken) => {
  const fd = new FormData();
  fd.append('avatar', file, file.name);

  return async (dispatch) => {
    dispatch(startedUploadingAvatar());
    try {
      const { data } = await axios.post('/users/me/avatar', fd, {
        headers: {
          'x-auth': localStorage.getItem('x-auth-token'),
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          dispatch(
            updateAvatarUploadProgress((progressEvent.loaded / progressEvent.total) * 100)
          );
        },
        cancelToken,
      });

      if (data.statusCode) {
        dispatch(failedUploadingAvatar(data.message));
      } else {
        dispatch(finishedUploadingAvatar());
      }
    } catch (e) {
      dispatch(failedUploadingAvatar('server.unexpected-error'));
    }
  };
};

const startedEditingProfile = () => {
  return {
    type: actionTypes.STARTED_EDITING_PROFILE,
  };
};

const editedProfile = (userData, isUploaded) => {
  return {
    type: actionTypes.EDITED_PROFILE,
    userData,
    isUploaded,
  };
};

const failedEditingProfile = () => {
  return {
    type: actionTypes.FAILED_EDITING_PROFILE,
  };
};

const editSuccess = (userData, isUploaded) => {
  return {
    type: actionTypes.EDIT_PROFILE_SUCCESS,
    userData,
    isUploaded,
  };
};

const failedEditingExecution = (message) => {
  return {
    type: actionTypes.EDIT_PROFILE_FAILED,
    message,
  };
};

export const editProfileRevamp = (userData, userId) => {
  return async (dispatch) => {
    dispatch(startedEditingProfile());
    try {
      const { data } = await axios.patch(`/users/me/${userId}`, userData, {
        headers: { 'x-auth': localStorage.getItem('x-auth-token') },
      });

      if (data.statusCode) {
        dispatch(failedEditingExecution(data.message));
      } else {
        dispatch(editSuccess(data.user, data.avatar));
      }
    } catch (e) {
      dispatch(failedEditingExecution('server.unexpected-error'));
    }
  };
};

export const editProfile = (dataObj, userId) => {
  return async (dispatch) => {
    dispatch(startedEditingProfile());
    console.log(dataObj);
    try {
      const { data } = await axios.patch(`/users/${userId}`, dataObj, {
        headers: { 'x-auth': localStorage.getItem('x-auth-token') },
      });
      const avatar = await axios.get(`/users/${userId}/avatar`);
      let isUploaded = true;

      if (avatar.data.code === -1) isUploaded = false;

      dispatch(editedProfile(data, isUploaded));
    } catch (e) {
      dispatch(failedEditingProfile());
    }
  };
};

export const resetEditingProfileState = () => {
  return {
    type: actionTypes.RESET_EDITING_PROFILE_STATE,
  };
};
